"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AsyncJobStatusModel", {
    enumerable: true,
    get: function() {
        return AsyncJobStatusModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const AsyncJobStatusModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    type: _zod.z.string(),
    time: _zod.z.date(),
    job_id: _zod.z.instanceof(_bson.ObjectId),
    result: _zod.z.unknown().optional(),
    error: _zod.z.unknown().optional(),
    workflow_id: _zod.z.instanceof(_bson.ObjectId).optional()
});
